import { Component, Input, OnInit, Output, EventEmitter, forwardRef } from '@angular/core';
import { ControlValueAccessor, FormControl, FormGroup, NG_VALUE_ACCESSOR, Validators } from '@angular/forms';

@Component({
  selector: 'app-html-editor',
  templateUrl: './html-editor.component.html',
  styleUrl: './html-editor.component.css',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => HtmlEditorComponent),
      multi: true,
    },
  ],
})
export class HtmlEditorComponent implements OnInit, ControlValueAccessor {
  @Input() formControlName: string;
  @Input() editorConfig: any;
  @Input() frm: FormGroup;
  modelo: any;

  constructor() {}

  ngOnInit(): void {

  }

  onChange: any = () => { };
  onTouched: any = () => { };

  get value() {
    return this.modelo;
  }

  set value(val) {
    
    this.modelo = val;
    this.onChange(val);
    this.onTouched();

  }

  writeValue(value: any): void {
    this.value = value;
  }

  registerOnChange(fn) {
    this.onChange = fn;
  }

  registerOnTouched(fn) {
    this.onTouched = fn;
  }

}
